var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"thumbs up\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.53357 2.42852L29.2083 2.42852C29.762 2.42852 30.2109 2.87736 30.2109 3.43114L30.2109 19.8073C30.2109 20.361 29.762 20.8099 29.2083 20.8099L24.5835 20.8099C23.4096 20.8099 22.3217 21.4259 21.7177 22.4325L17.1885 29.9812C16.2112 31.61 13.9093 31.7649 12.7227 30.2816C12.1634 29.5825 11.9831 28.6532 12.2404 27.7956L13.9489 22.1007C14.1419 21.4574 13.6601 20.8099 12.9886 20.8099L5.3434 20.8099C3.1398 20.8099 1.53928 18.7144 2.11913 16.5886L5.30931 4.89129C5.70585 3.43716 7.02647 2.42852 8.53357 2.42852Z",
    stroke: "#232323",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.3623 2.42914L24.3623 20.8105",
    stroke: "#232323",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs_down.86e7b6d0b14b08363d427dba1f1517ca.svg";
export { ForwardRef as ReactComponent };